import { commonEnvironment } from "./environment.common";

const env: Partial<typeof commonEnvironment> = { host: 'https://71qvcitoxl.execute-api.us-east-1.amazonaws.com/qa', proxy: true, apiKey: "BuE7gIOCjw487x2nJgkhV2lsDKTH3zGV9mryBE5D", enableInConstruction: true, GTM_ID: 'GTM-M9866MB' };


export const environment = { ...commonEnvironment, ...env };
